module.exports = __webpack_public_path__ + "img/fu1.f1533f0c.png";